import store from "@/store";

export const ResponseInterceptor = (response) => {
  store.commit("app/setConnected", true);
  return response;
};

export default ResponseInterceptor;
